import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import axios from "axios";

const postCaseData = async ({ data, params }) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  try {
    const response = await axios.post(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=addToTestSuites&companyid=${user.companyid}`,
      data,
      {
        params,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding to test suite:", error.response?.data?.error || error.message);
    throw error; 
  }
};

const useAddToSuiteMutation = (options = {}) => {
  return useMutation({
    mutationFn: postCaseData,
    ...options,
  });
};

export default useAddToSuiteMutation;
